import type { PlatformUser } from '@/api/types'
import { Badge } from '@/components/ui'

/** Super-admin / League admin / No league. */
export function UserRoleBadges({ user }: { user: Pick<PlatformUser, 'platform_role' | 'memberships'> }) {
  return (
    <span className="flex flex-wrap gap-1.5">
      {user.platform_role === 'super_admin' ? <Badge tone="accent">Super-admin</Badge> : null}
      {user.memberships.length ? <Badge tone="neutral">League admin</Badge> : null}
      {!user.platform_role && !user.memberships.length ? <Badge tone="outline">No league</Badge> : null}
    </span>
  )
}

export function UserStatusBadge({ active }: { active: boolean }) {
  return active ? <Badge tone="good">Active</Badge> : <Badge tone="bad">Deactivated</Badge>
}
